<template>
  <div class="col-md-2">
    <transportation-options value="261" @onChange="onOptionChange" />
  </div>
</template>

<script>
import TransportationOptions from '@/components/pei/service/components/transport-detail/TransportationOptions.vue';

export default {
  name: 'TransportNoDefined',
  components: {
    TransportationOptions,
  },
  methods: {
    onOptionChange(item) {
      this.$emit('onTransportTypeChange', item.id);
    },
  },
};
</script>
